export enum EModelQuality {
  FAST = 'fast', // Prioritize speed over intelligence like flash lite
  BALANCED = 'balanced', // Equal balance like flash 2.5
  SMART = 'smart', // Prioritize intelligence over speed like gemini pro 2.5
  SMART_THINKING = 'smart-thinking', // Maximum intelligence, ignore speed enable thinking mode
}

export const ModelQualityOptions = [
  { label: 'Fast', value: EModelQuality.FAST },
  { label: 'Balanced', value: EModelQuality.BALANCED },
  { label: 'Smart', value: EModelQuality.SMART },
  { label: 'Smart Thinking', value: EModelQuality.SMART_THINKING },
];
